import { useTranslation } from "react-i18next";
import PaymentMethodPicker from "@/components/PaymentMethodPicker/PaymentMethodPicker";
import { formatGrosze, tipFeeGrosze } from "@/helpers/cartPricing";
import {
  useCartActions,
  useCartBlikCode,
  useCartPaymentMethod,
  useCartSubtotal,
  useCartTipGrosze,
} from "@/store/useCartStore";
import { useTipFeeBps } from "@/store/useVenuesDataStore";
import styles from "./OrderPayment.module.scss";

function OrderPayment() {
  const { t } = useTranslation();
  const subtotal = useCartSubtotal();
  const tipGrosze = useCartTipGrosze();
  const paymentMethod = useCartPaymentMethod();
  const blikCode = useCartBlikCode();
  const { setPaymentMethod, setBlikCode } = useCartActions();

  const tipFeeBps = useTipFeeBps();
  const tipFee = tipFeeGrosze(tipGrosze, tipFeeBps);

  // The fee rides on the tip, so it only appears when there is a tip to charge
  // it on. The bill's own fee comes out of what the venue is paid and is not
  // the guest's to see.
  const rows = [
    { label: t("order.payment.subtotal"), value: subtotal },
    ...(tipGrosze > 0
      ? [{ label: t("order.payment.tip"), value: tipGrosze }]
      : []),
    ...(tipFee > 0
      ? [{ label: t("order.payment.checkoutFee"), value: tipFee }]
      : []),
  ];

  return (
    <div className={styles.orderPaymentContent}>
      <div className={styles.orderPaymentSummary}>
        {rows.map((row) => (
          <div key={row.label} className={styles.orderPaymentRow}>
            <p className={`title-medium ${styles.orderPaymentLabel}`}>
              {row.label}
            </p>
            <p className={`title-medium ${styles.orderPaymentValue}`}>
              {formatGrosze(row.value)}
            </p>
          </div>
        ))}
      </div>

      <p className={`title-medium ${styles.orderPaymentPayWith}`}>
        {t("order.payment.payWith")}
      </p>

      <PaymentMethodPicker
        selected={paymentMethod}
        onSelect={setPaymentMethod}
        blikCode={blikCode}
        setBlikCode={setBlikCode}
      />
    </div>
  );
}

export default OrderPayment;
